import request from '@/plugin/axios';
import api_sign from "@/libs/api_sign.js";
export function AccountLogin(data) {
  return request({
    url: '/admin/index/doLogin',
    method: 'post',
    data: api_sign(data)
  });
}